import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class VariantService {
  constructor(private http: HttpClient) {}

  getVariants(rowKey: string, year: string): Observable<any> {
    const paramData = {
      rowKey,
      year,
      source: "web"
    };
    return this.http.post(
      `${GlobalVariable.BASE_API_URL}/vehicle/getVehicleVariants`,
      paramData
    );
  }
}
